import { type TypedDocumentNode, gql } from '@apollo/client';
import classNames from 'classnames';
import { useState } from 'react';
import styled from 'styled-components';

import { TinderCardSwipe } from '../TinderCardSwipe';
import { PackTear } from './PackTear';
import type { RevealPackCards_anyCardInterface } from './__generated__/index.graphql';

const Root = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
  isolation: isolate;
`;
const TinderCardSwipeWrapper = styled.div`
  width: 100%;

  &.hidden {
    opacity: 0;
    position: absolute;
  }
`;
const PackTearWrapper = styled.div`
  width: 100%;
`;

type Props = {
  cards: RevealPackCards_anyCardInterface[];
  onContinue: () => void;
};
export const RevealPackCards = ({ cards, onContinue }: Props) => {
  const [packAnimationDone, setPackAnimationDone] = useState(false);

  return (
    <Root>
      <TinderCardSwipeWrapper
        className={classNames({ hidden: !packAnimationDone })}
      >
        <TinderCardSwipe cards={cards} onContinue={onContinue} />
      </TinderCardSwipeWrapper>
      {!packAnimationDone && (
        <PackTearWrapper>
          <PackTear
            onDone={() => {
              setPackAnimationDone(true);
            }}
            firstCardUrl={cards[0].pictureUrl || ''}
          />
        </PackTearWrapper>
      )}
    </Root>
  );
};

RevealPackCards.fragments = {
  anyCardInterface: gql`
    fragment RevealPackCards_anyCardInterface on AnyCardInterface {
      slug
      pictureUrl
      ...TinderCardSwipe_anyCardInterface
    }
    ${TinderCardSwipe.fragments.anyCardInterface}
  ` as TypedDocumentNode<RevealPackCards_anyCardInterface>,
};
